import { IconFacebook, IconInstagram, IconTelegram, IconTiktok } from '@/app/shared/icons'

export const generateIcon = (slug: string, classList: string) => {
  switch (slug) {
    case 'telegram': {
      return <IconTelegram className={classList} />
    }
    case 'tiktok': {
      return <IconTiktok className={classList} />
    }
    case 'facebook': {
      return <IconFacebook className={classList} />
    }
    default: {
      return <IconInstagram className={classList} />
    }
  }
}
